import React from 'react';
import './stylesheets/becomeaseller.css';
import Headertop from '../components/Headertop';
import Header from '../components/Header';
import Servicestopbar from '../components/Servicestopbar';
import { NavLink } from 'react-router-dom';
import Footer from '../components/Footer';

function Becomeaseller() {
  return (
    // <!-- For all screen -->
    <div className="page text-center"> {/* Apply text-center class here */}
      <Headertop />
      <Header />
      <Servicestopbar />
      {/* <!-- Login & Signup in a single row --> */}
      <div className="row">
        {/* <!-- Column for signin --> */}
        <div className="col-sm-8 text-center signin">
          {/* <!-- Default form login --> */}
          <form action="#!">
            <p className="h4 mb-4 text-center signintext top"><strong>Sign in to your account</strong></p>
            {/* <!-- Login with Social Media Buttons --> */}
            <div className="social-btn text-center">
              <a href="#" className="btn btn-fb btn-lg" title="Facebook"><i className="fa fa-facebook"></i> Facebook</a><br />
              <a href="#" className="btn btn-x btn-lg" title="Twitter"><i className="fa fa-twitter"></i> Twitter</a><br />
              <a href="#" className="btn btn-pinterest btn-lg" title="Pinterest"><i className="fa fa-pinterest"></i> Pinterest</a><br />
            </div>
            <p className="text-center signintext">Or use your Email account</p>
            {/* <!-- Email --> */}
            <input type="email" className="form-control mb-4e" placeholder="&#xf0e0; Email" /><br />
            {/* <!-- Password --> */}
            <input type="password" className="form-control mb-4p" placeholder="&#xf023; Password" /><br />
            {/* <!-- Sign in button --> */}
            <div className='meriadiv'>
              <a className="ForgotPassBtn" href="">Forgot Your Password?</a><br />
            </div>
            <button className="btn btn-info btn-block LoginBtn" type="submit">LOGIN</button>
            <p>don't have an account? <a href='#'>Sign Up</a></p>
          </form>
        </div>
        {/* <!-- Column for signup --> */}
        <div className="col-sm-4 signup text-center">
          <h2 className="HelloFriend">Hello, Friend!</h2>
          <h4 className="SignupText">Enter your personal details<br />and start selling now!</h4>
          <button className="btn btn-info btn-block ssbtn" type="submit">
            <NavLink to='/startselling' className="ssnavlink">START SELLING</NavLink>
          </button>
        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default Becomeaseller;
